// extracted by mini-css-extract-plugin
module.exports = {"button":"_2fJ0dtXS_ZTgF_-4a0etce"};